module.exports = __webpack_public_path__ + "media/images/hub-config-icon-f8a146b3fc3c5ad3f5c412c9fe1c7d80.svg";